import { MatSort } from '@angular/material/sort';
import { Sale } from 'src/app/models/sales/sales.model';
import { MatDataSource } from 'src/app/shared-new/util/mat-datasource';

export class SaleIndexDataSource extends MatDataSource<Sale> {
  public constructor(
    data: Sale[],
    sort: MatSort,
    disableInfiniteScroll: boolean = false,
    scrollLevel: number = 20
  ) {
    super(data, sort, disableInfiniteScroll, scrollLevel);
    this.setFilterPredicate();
    this.sortingDataAccess();
  }

  setFilterPredicate(): void {
    this.filterPredicate = (sale: Sale, filterValue: string) => {
      return 'saleName,repositoryLocation,location'.split(',').some((key) => {
        return (
          sale[key as keyof Sale] &&
          new RegExp(filterValue.trim().toLowerCase(), 'gi').test(
            sale[key as keyof Sale]
          )
        );
      });
    };
  }
sortingDataAccess(): void {
  const dateColumns = new Set(['viewStartDate', 'sellingStartDate', 'startDate']);
  this.sortingDataAccessor = (data: Sale, sortHeaderId: string): any => {
    if (dateColumns.has(sortHeaderId)) {
      const value = data[sortHeaderId as keyof Sale];
      // Only parse if value is a valid date string
      const parsed = typeof value === 'string' ? Date.parse(value) : NaN;
      return !isNaN(parsed) ? new Date(parsed).toISOString() : value ?? '';
    }
    // Default: return property or empty string if undefined/null
    return data[sortHeaderId as keyof Sale] ?? '';
  };
}



  public filter2<T>(filter: any): void {
    const test: T[] = [];
    const filteredsData = test.filter((clinicStudy) => {
      Object.keys(filter).forEach((key) => {
        return filter[key] === clinicStudy[key as keyof T];
      });
    });
  }
}
